const minAge = (value, minimum = 18) => {
  const nowDate = new Date(Date.now())
  /**
   * Convert brazilian format to global format => DD/MM/YYYY => MM/DD/YYYY
   * */
  const normalized = value.replace(/(\d{2})\/(\d{2})\/(\d{4})/g, '$2/$1/$3')
  const birthDate = new Date(normalized)
  let age = nowDate.getFullYear() - birthDate.getFullYear()
  const month = nowDate.getMonth() - birthDate.getMonth()
  if (month < 0 || (month === 0 && nowDate.getDate() < birthDate.getDate())) {
    age -= 1
  }
  if (age < minimum) return false
  return true
}

const maxAge = (value, maximum = 135) => {
  const nowDate = new Date(Date.now())
  /**
   * Convert brazilian format to global format => DD/MM/YYYY => MM/DD/YYYY
   * */
  const normalized = value.replace(/(\d{2})\/(\d{2})\/(\d{4})/g, '$2/$1/$3')
  const birthDate = new Date(normalized)
  let age = nowDate.getFullYear() - birthDate.getFullYear()
  const month = nowDate.getMonth() - birthDate.getMonth()
  if (month < 0 || (month === 0 && nowDate.getDate() < birthDate.getDate())) {
    age -= 1
  }
  if (age > maximum) return false
  return true
}

export { minAge, maxAge }
